import React, { useRef, useEffect, useState } from 'react'
import './styles/multiplayer-lobby.css'
import '../../styles/fancy-text.css'
import '../styles/home-page-buttons.css'
import '../styles/home-page.css'
import FancyText from '../FancyText'
import asuTempeCampus from '../../images/asu-tempe-campus.jpg'  
import HomePageHeaders from '../HomePageHeaders'
import axios from 'axios'
import { useNavigate } from "react-router-dom";
const { io } = require("socket.io-client")

export default function MultiplayerLobby({ handleClick }){
    const socket = io('https://www.asuguesser.com')
    const [ASUHeaderFancyText, setASUHeaderFancyText] = useState(<FancyText InnerTextID={'asu-guesser-fancy-text-id'}/>)
    const [currentDifficultySelection, setCurrentDifficultySelection] = useState(null)
    const [listOfPlayers, setListOfPlayers] = useState([])

    let navigate = useNavigate();

    useEffect(() => {
        setTimeout(()=>{
          document.getElementById('home-page-multiplayer-lobby-wrapper').style.transform = 'translateY(0)'
        }, 10)

        socket.on("lobby_update", data => {
            //setLobbyPlayers(data.players);
        });

        socket.on("your_sorted_list", data => {
            //setSortedPlayers(data.players);
        });

        return () => {
            socket.off("lobby_update");
            socket.off("your_sorted_list");
        };
    }, [])

    function easyClick(){
        console.log(8923)
        // socket.emit('randomTest')
    }

    function mediumClick(){
        console.log(23)
    }

    function multiplayerHomePageBackButton(){
        navigate('/')
    }

    
    return(
        <div className='background-image-wrapper'>
        <div className='background-image-filter'></div>
        <img id='background-image'src={asuTempeCampus} draggable="false" className='background-image' alt='asu tempe campus background' />
        
        <div id="home-page-content" className='home-page-content'>
          <HomePageHeaders />
          <div className='asu-header-wrapper'>
            {ASUHeaderFancyText}
          </div>

          <div id='home-page-multiplayer-lobby-wrapper' className='home-page-multiplayer-lobby-wrapper'>
            <div className='home-page-multiplayer-lobby-players-wrapper'>
                {listOfPlayers}
            </div>
            

            <div className='home-page-multiplayer-lobby-settings-wrapper'>
                <select name='difficulty' className='home-page-multiplayer-lobby-settings-difficulty'  onClick={easyClick} onSelect={mediumClick}>
                    <option value='easy'>Easy</option>
                    <option value='medium'>Medium</option>
                    <option value='hard'>Hard</option>
                    <option value='impossible'>Impossible</option>
                </select>
            </div>
            <div className='home-screen-game-start-button'>
                <FancyText InnerTextID={'start-game'}/>
            </div>
        </div>
          <div id='multiplayer-lobby-back-button' className='multiplayer-lobby-back-button' onClick={multiplayerHomePageBackButton}>
            Back!
          </div>
        </div>
        
      </div>


        
    )
}

